import React, { HTMLAttributes } from 'react';
import CountUp from 'react-countup';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphMetricItem as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphMetricItemProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphMetricItem: React.FC<ParagraphMetricItemProps> = ({
  entity,
}) => {
  const paragraph = entity.toJS();

  const label = paragraph.field_label[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const number = paragraph.field_value[0].value;
  const suffix = paragraph.field_suffix[0]?.value;
  const prefix = paragraph.field_prefix[0]?.value;
  const unit = paragraph.field_unit[0]?.value;

  const decimals = String(number).split('.');

  return (
    <div className="ParagraphMetricItem">
      <div className="ParagraphMetricItem__number">
        {prefix && (
          <span>{prefix} </span>
        )}
        <CountUp
          end={number}
          decimals={decimals[1] ? decimals[1].length : 0}
          decimal=","
          separator="."
          duration={4}
          enableScrollSpy
          scrollSpyOnce
          scrollSpyDelay={300}
        />
        {suffix && (
          <span> {suffix}</span>
        )}
        {unit && <span className="ParagraphMetricItem__unit"> {unit}</span>}
      </div>
      {label && <div className="ParagraphMetricItem__label">{label}</div>}
      {body && (
        <div className="ParagraphMetricItem__body">
          <WysiwygField html={body} />
        </div>
      )}
    </div>
  );
};

export default ParagraphMetricItem;
